import { Cartesian3 } from 'cesium';

import type {
  CameraPosition,
  CameraPositionStr,
} from '../types/CameraPosition';
import type { ShareKey } from '../types/ShareKey';
import type { Viewer } from 'cesium';

export const shareKeys: ShareKey[] = [
  'resources',
  'base',
  'terrain',
  'position',
  'direction',
  'up',
];

export function getCameraPosition(map: unknown): CameraPositionStr {
  const camera = (map as Viewer).camera;

  const store: CameraPositionStr = {
    position: _cartesianToString(camera.position),
    direction: _cartesianToString(camera.direction),
    up: _cartesianToString(camera.up),
    // optional
    // right: camera.right.clone(),
    // transform: camera.transform.clone(),
    // frustum: camera.frustum.clone(),
  };
  return store;
}

export function watchCameraPosition(
  map_: unknown,
  cb: (pos: CameraPositionStr) => void,
): () => void {
  const map = map_ as Viewer;

  return map.camera.moveEnd.addEventListener(() => {
    cb(getCameraPosition(map));
  });
}

export function setCameraPosition(
  map: unknown,
  pos: Partial<CameraPositionStr>,
): void {
  _setCameraPosition(map, receiveCameraPosition(pos));
}

function receiveCameraPosition(
  posStr: Partial<CameraPositionStr>,
): Partial<CameraPosition> {
  const pos: Partial<CameraPosition> = {};

  let p: keyof typeof posStr;
  for (p in posStr) {
    const prop = posStr[p];
    if (prop) {
      (pos as any)[p] = _strToCartesian(prop);
    }
  }
  return pos;
}

function _setCameraPosition(map: unknown, pos: Partial<CameraPosition>): void {
  const camera = (map as Viewer).camera;

  let p: keyof CameraPosition;
  for (p in pos) {
    const prop = pos[p];
    if (prop) {
      (camera as any)[p] = prop;
    }
  }
}

function _strToCartesian(str: string): Cartesian3 {
  const [x, y, z] = str.split(',').map(Number);
  return new Cartesian3(x, y, z);
}

function _cartesianToString(cart: Cartesian3): string {
  return [cart.x, cart.y, cart.z].join(',');
}
